import DefaultTransformer from './transformers/default'
import WorldUsaTransformer from './transformers/world-usa'
import UsaStateTransformer  from './transformers/usa-state'
import NorthAmericaUsaTransformer from './transformers/north-america-usa'
import NorthAmericaTransformer from './transformers/north-america'
import DimensionsTransformer from './transformers/dimensions'
import MultiFeatureTransformer from './transformers/multi-feature-zoom'
import GlobeToFeatureTransformer from './transformers/globe-to-feature'
import FeatureToGlobeTransformer from './transformers/feature-to-globe'
import NoopDeemphasizeTransformer from './transformers/noop-deemphasize'

class Controller {

  constructor () {
    // Order matters as the first transformer that matches will be used
    // for the projection transformation
    this._transformers = [
      NoopDeemphasizeTransformer,
      FeatureToGlobeTransformer,
      GlobeToFeatureTransformer,
      UsaStateTransformer,
      WorldUsaTransformer,
      NorthAmericaUsaTransformer,
      NorthAmericaTransformer,
      DimensionsTransformer,
      MultiFeatureTransformer,
      DefaultTransformer
    ]
  }

  /*
   * Returns the transformer to use given the entering and exiting plot
   * selections
   */
  getTransformer (entering, exiting, options) {
    const d0 = !!exiting.size() && exiting.datum()
        , d1 = entering.datum()
        , depth0 = exiting.size() ? d0.node.depth : -Infinity
        , depth1 = d1.node.depth
        , zoomOut = depth0 > depth1 // Determine if we're zooming in or out
        , opts = Object.assign({}, options, {
          transition: !!options.duration,
          zoomOut
        })

    let Transformer = this._transformers.find(Transformer => {
      return Transformer.match(d0, d1, opts)
    })

    return new Transformer(entering, exiting, opts)
  }

}

export default Controller
